import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    const promptEvent = window.deferredPrompt || deferredPrompt;
    if (promptEvent) {
      promptEvent.prompt();
      const { outcome } = await promptEvent.userChoice;
      if (outcome === 'accepted') {
        window.deferredPrompt = null;
        setDeferredPrompt(null);
      }
    } else {
      alert("Installation prompt is not available right now. You can manually install the app by clicking the 'Install' icon in your URL address bar, or by selecting 'Add to Home Screen' from your mobile browser menu.");
    }
  };

  return (
    <div className="app-container">
      <Sidebar />
      <div className="main-content">
        <div className="header-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2.5rem', flexWrap: 'wrap', gap: '1rem' }}>
          <h2 style={{ margin: 0 }}>Welcome back!</h2>
          <div className="header-actions" style={{ display: 'flex', gap: '1rem' }}>
            <button 
              onClick={handleInstallClick}
              className="btn btn-primary" 
              style={{ padding: '0.5rem 1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
            >
              ⬇️ Install App
            </button>
            <button className="btn" style={{ background: '#f3f4f6', color: '#475569' }}>🔔</button>
            <button className="btn" style={{ background: '#8b5cf6', color: '#fff', borderRadius: '50%', width: '40px', padding: '0' }}>👤</button>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Layout;
